var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.value==1)?_c('span',{staticStyle:{"color":"green"}},[_vm._v("是")]):_c('span',{staticStyle:{"color":"red"}},[_vm._v("否")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9c07427c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/kc/keTemp/status/kcStatusYnEn.vue
// module id = null
// module chunks = 